import React from "react";
import AddIcon from "../../icons/AddIcon";

interface Props {
  items: string[];
  onSelect: (value: string) => void;
}

const SuggestionsDropdown: React.FC<Props> = ({ items, onSelect }) => {
  return (
    <div className="qs_sd_suggestion">
      <div className="qs_sd_title">Suggested keywords</div>
      <div className="qs_sd_chip_container">
        {items.map((item) => (
          <div className="qs_sd_chip" onClick={() => onSelect(item)} key={item}>
            <span>{item}</span>
            <span className="qs_sd_chip_icon">
              <AddIcon />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuggestionsDropdown;
